<a-center-popup [title]="'Release Sprint'" class="big_popup" (close)="onClose()">
  <release-form
    [board]="board$ | async"
  ></release-form>
</a-center-popup>
